import * as React from 'react';
import { useFocused } from "./useFocused";
import TextInput from "./TextInput";
import { Flex, InlineField, InlineFieldActions, InlineFieldAction, InlineFieldInfoAction } from "./..";
import { Divider } from "../divider";
import { isEmpty } from "../../helpers/data";

var NumberField = function NumberField(_ref) {
  var icon = _ref.icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      value = _ref.value,
      placeholder = _ref.placeholder,
      label = _ref.label,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      error = _ref.error,
      required = _ref.required,
      validated = _ref.validated,
      helperText = _ref.helperText,
      fullWidth = _ref.fullWidth,
      min = _ref.min,
      max = _ref.max,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      unit = _ref.unit,
      info = _ref.info,
      autoFocus = _ref.autoFocus;

  var _useFocused = useFocused({
    onFocus: onFocus,
    onBlur: onBlur
  }),
      isFocused = _useFocused.isFocused,
      onBlurHandler = _useFocused.onBlur,
      onFocusHandler = _useFocused.onFocus;

  var onClearHandler = React.useCallback(function () {
    onChange('');
  }, [onChange]);
  var onChangeHandler = React.useCallback(function (newValue) {
    if (newValue === '') {
      onClearHandler();
      return;
    }

    if (!isEmpty(min) && Number(newValue) < min) {
      return;
    }

    if (!isEmpty(max) && Number(newValue) > max) {
      return;
    }

    onChange(Number(newValue));
  }, [max, min, onChange, onClearHandler]);
  var onIncrement = React.useCallback(function () {
    var incrementedValue = (value || 0) + step;
    var newValue = max !== undefined && incrementedValue >= max ? max : incrementedValue;
    onChange(newValue);
  }, [max, onChange, step, value]);
  var onDecrement = React.useCallback(function () {
    var decrementedValue = (value || 0) - step;
    var newValue = min !== undefined && decrementedValue <= min ? min : decrementedValue;
    onChange(newValue);
  }, [min, onChange, step, value]);
  var showPlaceholder = !value && isFocused;
  var labelWithUnit = unit && label ? "".concat(label, " (").concat(unit, ")") : label;
  return /*#__PURE__*/React.createElement(InlineField, {
    size: size,
    label: labelWithUnit,
    icon: icon,
    disabled: disabled,
    isInputFocused: isFocused,
    value: value,
    error: error,
    helperText: helperText,
    required: required,
    validated: validated,
    fullWidth: fullWidth
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "stretch",
    width: "100%"
  }, /*#__PURE__*/React.createElement(TextInput, {
    type: "number",
    value: value,
    size: size,
    disabled: disabled,
    placeholder: showPlaceholder ? placeholder : null,
    onChange: onChangeHandler,
    onFocus: onFocusHandler,
    onBlur: onBlurHandler,
    autoFocus: autoFocus
  }), !disabled && /*#__PURE__*/React.createElement(InlineFieldActions, null, info && /*#__PURE__*/React.createElement(InlineFieldInfoAction, {
    info: info
  }), value !== '' && !isNaN(value) && /*#__PURE__*/React.createElement(InlineFieldAction, {
    icon: "cross_circle",
    onClick: onClearHandler
  }), /*#__PURE__*/React.createElement(Divider, {
    type: "inline",
    inlineSeparator: "vertical",
    color: "grey.300"
  }), /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(InlineFieldAction, {
    icon: "arrow_chevron_up",
    disabled: max !== undefined && (value || 0) >= max,
    onClick: onIncrement
  }), /*#__PURE__*/React.createElement(InlineFieldAction, {
    icon: "arrow_chevron_down",
    disabled: min !== undefined && (value || 0) <= min,
    onClick: onDecrement
  })))));
};

export { NumberField };
export default NumberField;